import React from 'react';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Switch from '@material-ui/core/Switch';
import Select from '@material-ui/core/Select';
import Paper from '@material-ui/core/Paper';
import LinearProgress from '@material-ui/core/LinearProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';

import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';

import Avatar from '@material-ui/core/Avatar';
import { mascaraCelular9Digito, formataDataDDMMYYYYParaHTML5, formataDataHTML5ParaDDMMYYYY } from '../modules/util';
import CONSTANTS from '../constants';
import { CheckBox } from '@material-ui/icons';



export default class DadosInteressado extends React.Component {

    componentDidMount() {
        setTimeout(() => {
            document.querySelector(".scrollView").scrollIntoView({ behaviour: "smooth" });
        }, 200);
        this.props.getListDeficiencia();
    }


    render() {

        var cpf = (
            <div style={{
                textAlign: "center"
            }}>
                <FormControl className='item-form'
                    style={{
                        textAlign: "center"
                    }}>

                    <TextField
                        type="number"
                        style={{ width: "150px" }}
                        id="pes-cpf"
                        label="CPF"
                        value={this.props.pesCPF > 0 ? this.props.pesCPF : ""}
                        onChange={(e) => this.props.changeCampoGenericoInteressado('pesCPF', e.target.value)}
                        margin="normal"
                        helperText={"Somente números"}

                    />
                    <Button
                        disabled={this.props.carregandoPessoaCPF}
                        onClick={this.props.onContinuarCPF} variant="raised" color="primary" >
                        Continuar
                    </Button>
                </FormControl>
            </div>
        );
        var msgDadosJaCadastrado = "Dados cadastrais estão de acordo com o seu registro na Unoeste. Caso haja algum erro, por favor, procure o Departamento Pessoal para realizar a atualização.";

        var divMsgCadastroExiste = (
            <div
                className=""
                style={{
                    margin: "20px  0",
                    border: "1px solid #ccc",
                    padding: "20px",
                    backgroundColor: "rgb(255, 254, 209)"
                }}>
                <Typography variant="caption" gutterBottom align="center">
                    {msgDadosJaCadastrado}
                </Typography>
            </div>
        );
        var outrosDados = (
            <div>
                {this.props.permissaoAlterar !== CONSTANTS._PERMISSAO.tudo ? divMsgCadastroExiste : null}
                <fieldset>
                    <legend>Dados Básicos</legend>
                    <div>
                        <FormControl className='item-form'
                            style={{
                                textAlign: "center"
                            }}>

                            <TextField
                                type="number"
                                disabled={true}
                                style={{ width: "170px" }}
                                id="pes-cpf"
                                label="CPF"
                                value={this.props.pesCPF > 0 ? this.props.pesCPF : ""}
                                onChange={(e) => this.props.changeCampoGenericoInteressado('pesCPF', e.target.value)}
                                margin="normal"
                                InputProps={{
                                    endAdornment: <InputAdornment position="end"> <IconButton onClick={this.props.onEditarCPF} variant="fab" size="small" title="Editar"><EditIcon /></IconButton ></InputAdornment>,
                                }}
                            />

                        </FormControl>
                    </div>



                    <FormControl className='item-form' style={{ width: "10%", minWidth: "150px" }}  >
                        <InputLabel htmlFor='nacCodigo'>Nacionalidade</InputLabel>
                        <Select

                            id='nacCodigo'
                            error={this.props.campoErros.nacCodigo}

                            disabled={this.props.permissaoAlterar !== CONSTANTS._PERMISSAO.tudo}
                            value={this.props.nacCodigo}
                            onChange={(e) => this.props.changeCampoGenericoInteressado('nacCodigo', e.target.value)}
                        >
                            {this.props.listNacionalidade.map((item) => {
                                return (
                                    <MenuItem key={item.nac_codigo} value={item.nac_codigo}>{item.nac_descricao}</MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>


                    <FormControl className='item-form' style={{ width: "40%", minWidth: "320px" }} >

                        <TextField
                            error={this.props.campoErros.pesNome}
                            disabled={this.props.permissaoAlterar !== CONSTANTS._PERMISSAO.tudo}
                            type="text"
                            fullWidth
                            id="pes-nome"
                            label="Nome"
                            value={this.props.pesNome}
                            onChange={(e) => this.props.changeCampoGenericoInteressado('pesNome', e.target.value)}
                            margin="normal"
                        />

                    </FormControl>

                    <FormControl className='item-form' style={{ width: "30%" }}  >
                        <TextField
                            error={this.props.campoErros.emlEmail}
                            disabled={this.props.permissaoAlterar !== CONSTANTS._PERMISSAO.tudo}
                            type="text"
                            fullWidth
                            id="email"
                            label="E-mail"
                            value={this.props.emlEmail}
                            onChange={(e) => this.props.changeCampoGenericoInteressado('emlEmail', e.target.value)}
                            margin="normal"
                        />
                    </FormControl>

                    <FormControl className='item-form' style={{ width: "15%", minWidth: '150px' }}  >
                        <TextField
                            error={this.props.campoErros.pesDtNasc}
                            disabled={this.props.permissaoAlterar !== CONSTANTS._PERMISSAO.tudo}
                            type="date"
                            fullWidth
                            id="pesDtNasc"
                            label="Data de Nascimento"
                            value={formataDataDDMMYYYYParaHTML5(this.props.pesDtNasc) || '0000-00-00'}
                            onChange={(e) => { this.props.changeCampoGenericoInteressado('pesDtNasc', formataDataHTML5ParaDDMMYYYY(e.target.value)); }}
                            margin="normal"
                        />
                    </FormControl>
                    <div>
                        <FormControl className='item-form' style={{ width: "10%", minWidth: "120px" }}  >
                            <TextField
                                error={this.props.campoErros.pesRG}
                                disabled={this.props.permissaoAlterar !== CONSTANTS._PERMISSAO.tudo}
                                type="text"
                                fullWidth
                                id="pes-rg"
                                label="RG"
                                value={this.props.pesRG}
                                onChange={(e) => this.props.changeCampoGenericoInteressado('pesRG', e.target.value)}
                                margin="normal"
                            />
                        </FormControl>
                        <FormControl className='item-form' style={{ width: "10%", minWidth: "120px" }}  >
                            <TextField
                                InputProps={{ maxLength: 10 }}
                                error={this.props.campoErros.pesOrgExp}
                               
                                type="text"
                                fullWidth
                                placeholder="SSP"
                                label="Orgão Expedidor  "
                                value={this.props.pesOrgExp}
                                onChange={(e) => this.props.changeCampoGenericoInteressado('pesOrgExp', e.target.value)}
                                margin="normal"
                            />



                        </FormControl>

                        <FormControl className='item-form' style={{ width: "10%", minWidth: "150px" }}  >
                            <InputLabel htmlFor='pesEstExp'>Estado Expedidor</InputLabel>
                            <Select

                                id='pesEstExp'
                                error={this.props.campoErros.pesEstExp}

                                disabled={this.props.permissaoAlterar !== CONSTANTS._PERMISSAO.tudo}
                                value={this.props.pesEstExp}
                                onChange={(e) => this.props.changeCampoGenericoInteressado('pesEstExp', e.target.value)}
                            >
                                {this.props.listEstados.map((item) => {
                                    return (
                                        <MenuItem key={item} value={item}>{item}</MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>

                        <FormControl className='item-form' style={{ width: "12%", minWidth: "120px" }}  >
                            <TextField
                                error={this.props.campoErros.pesTelefone}
                              
                                type="text"
                                fullWidth
                                placeholder="(00)0000-0000"
                                id="pes-telefone"
                                label="Telefone Fixo"
                                value={mascaraCelular9Digito(this.props.pesTelefone)}
                                onChange={(e) => this.props.changeCampoGenericoInteressado('pesTelefone', mascaraCelular9Digito(e.target.value))}
                                margin="normal"
                            />
                        </FormControl>

                        <FormControl className='item-form' style={{ width: "12%", minWidth: "120px" }}  >
                            <TextField
                                error={this.props.campoErros.pesCelular }                               
                                type="text"
                                fullWidth
                                placeholder="(00)00000-0000"
                                id="pes-celular"
                                label="Celular"
                                value={mascaraCelular9Digito(this.props.pesCelular)}
                                onChange={(e) => this.props.changeCampoGenericoInteressado('pesCelular', mascaraCelular9Digito(e.target.value))}
                                margin="normal"
                            />

                        </FormControl>
                        <FormControl className='item-form' >
                            <InputLabel >Sexo</InputLabel>
                            <Select
                                disabled={this.props.permissaoAlterar !== CONSTANTS._PERMISSAO.tudo}
                                error={this.props.campoErros.pesSexo}
                                style={{ width: "200px" }}
                                value={(this.props.pesSexo || 0).toString()}
                                onChange={(e) => this.props.changeCampoGenericoInteressado('pesSexo', e.target.value)}
                            >
                                <MenuItem value={'0'}>--Selecione--</MenuItem>
                                <MenuItem value={'1'}>Masculino</MenuItem>
                                <MenuItem value={'2'}>Feminino</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </fieldset>
                <fieldset>
                    <legend>Indique se você possui algum tipo de deficiência</legend>
                    <FormControl className='item-form' >
                        <InputLabel >Possui Alguma Deficiência?</InputLabel>
                        <Select
                            error={this.props.campoErros.possuiAlgumaDeficiencia}
                            style={{ width: "200px" }}
                            value={this.props.possuiAlgumaDeficiencia}
                            onChange={(e) => this.props.changeCampoGenericoInteressado('possuiAlgumaDeficiencia', e.target.value)}
                        >
                            <MenuItem value={"S"}>SIM</MenuItem>
                            <MenuItem value={"N"}>NÃO</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl
                        disabled={this.props.possuiAlgumaDeficiencia !== "S"}
                        className='item-form' >
                        <InputLabel >Selecione a Deficiência</InputLabel>
                        <Select
                            error={this.props.campoErros.tdfCodigo}
                            style={{ width: "200px" }}
                            value={this.props.tdfCodigo}
                            onChange={(e) => this.props.changeCampoGenericoInteressado('tdfCodigo', e.target.value)}
                        >
                            {this.props.listDeficiencias.map((item) => {
                                return (
                                    <MenuItem key={item.TdfCodigo} value={item.TdfCodigo}>{item.TdfDescricao}</MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                </fieldset>

                <fieldset>
                    <legend>Endereço</legend>

                    <FormControl className='item-form' style={{ width: "12%", minWidth: "120px" }}  >
                        <TextField
                            error={this.props.campoErros.pesCEP}
                            disabled={this.props.permissaoAlterar === CONSTANTS._PERMISSAO.naoPermitido}
                            onBlur={(e) => { this.props.onConsultaCEP(e.target.value) }}
                            type="text"
                            fullWidth
                            placeholder="00000-000"
                            id="pes-cep"
                            label="CEP"
                            value={this.props.pesCEP}
                            onChange={(e) => this.props.changeCampoGenericoInteressado('pesCEP', e.target.value)}
                            margin="normal"
                        />
                        {this.props.carregandoCEP ? <LinearProgress /> : null}
                    </FormControl>

                    <FormControl className='item-form' style={{ width: "40%", minWidth: "320px" }}  >


                        <TextField
                            error={this.props.campoErros.pesRua}
                            disabled={this.props.carregandoCEP || this.props.permissaoAlterar === CONSTANTS._PERMISSAO.naoPermitido}
                            type="text"
                            fullWidth
                            id="pesRua"
                            label="Endereço"
                            value={(this.props.pesRua)}
                            onChange={(e) => this.props.changeCampoGenericoInteressado('pesRua', (e.target.value))}
                            margin="normal"
                            helperText={"Ex: Rua Fulano de Tal, 999 - Apt. 999"}
                        />
                    </FormControl>

                    <FormControl className='item-form' style={{ width: "40%", minWidth: "220px" }}  >
                        <TextField
                            error={this.props.campoErros.pesBairro}
                            disabled={this.props.carregandoCEP || this.props.permissaoAlterar === CONSTANTS._PERMISSAO.naoPermitido}
                            type="text"
                            fullWidth
                            id="pes-bairro"
                            label="Bairro"
                            value={(this.props.pesBairro)}
                            onChange={(e) => this.props.changeCampoGenericoInteressado('pesBairro', (e.target.value))}
                            margin="normal"
                        />
                    </FormControl>

                    <FormControl
                        className='item-form' >
                        <InputLabel >Estado</InputLabel>
                        <Select
                            error={this.props.campoErros.uf}
                            style={{ width: "120px" }}
                            disabled={this.props.carregandoCEP || this.props.permissaoAlterar === CONSTANTS._PERMISSAO.naoPermitido || this.props.carregandoCidades || this.props.locCodigo > 0}
                            readOnly={this.props.locCodigo > 0}
                            value={this.props.uf}
                            onChange={(e) => this.props.onChancheUF(e.target.value)}
                        >
                            {this.props.listEstados.map((item) => {
                                return (
                                    <MenuItem key={item} value={item}>{item}</MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>

                    <FormControl style={{ width: "40%", minWidth: "220px" }}
                        className='item-form' >
                        <InputLabel >Cidade</InputLabel>
                        <Select
                            error={this.props.campoErros.locCodigo}
                            disabled={this.props.carregandoCEP || this.props.permissaoAlterar === CONSTANTS._PERMISSAO.naoPermitido || this.props.carregandoCidades || this.props.locCodigo > 0}                            
                            readOnly={this.props.locCodigo > 0}
                            native
                            style={{}}
                            value={this.props.locCodigo || "0"}
                            onChange={(e) => this.props.changeCampoGenericoInteressado('locCodigo', e.target.value)}
                        >
                            <option value="0" >--SELECIONE--</option>
                            {this.props.listCidades.map((item) => {
                                return (
                                    <option style={{ backgroundColor: "#fff" }} key={item.loc_codigo} value={item.loc_codigo}>{item.loc_nome.trim()}</option>
                                );
                            })}
                        </Select>
                    </FormControl>
                </fieldset>

                <fieldset>
                    <legend>Empresa</legend>


                    <FormControl className='item-form' style={{ width: "40%", minWidth: "220px" }}  >
                        <TextField
                            type="text"
                            fullWidth
                            id="pesEmpresa"
                            label="Empresa onde trabalha"
                            value={(this.props.pesEmpresa)}
                            onChange={(e) => this.props.changeCampoGenericoInteressado('pesEmpresa', (e.target.value))}
                            margin="normal"
                        />
                    </FormControl>

                    <FormControl className='item-form' style={{ width: "15%", minWidth: '150px' }}  >
                        <TextField
                            type="date"
                            fullWidth
                            id="pesDtAdmissao"
                            label="Data de Admissão"
                            value={formataDataDDMMYYYYParaHTML5(this.props.pesDtAdmissao) || '0000-00-00'}
                            onChange={(e) => this.props.changeCampoGenericoInteressado('pesDtAdmissao', formataDataHTML5ParaDDMMYYYY(e.target.value))}
                            margin="normal"
                        />
                    </FormControl>

                    <FormControl className='item-form' style={{ width: "40%", minWidth: "220px" }}  >
                        <TextField
                            type="text"
                            fullWidth
                            id="pesCargo"
                            label="Cargo/Profissão"
                            value={(this.props.pesCargo)}
                            onChange={(e) => this.props.changeCampoGenericoInteressado('pesCargo', (e.target.value))}
                            margin="normal"
                        />
                    </FormControl>

                    <FormControl className='item-form' style={{ width: "40%", minWidth: "220px" }}  >
                        <InputLabel htmlFor="pesRendaBruta">Renda pessoal bruta mensal</InputLabel>
                        <Input
                            type="text"
                            fullWidth
                            id="pesRendaBruta"
                            placeholder="00,00"
                            value={(this.props.pesRendaBruta)}
                            onChange={(e) => this.props.changeCampoGenericoInteressado('pesRendaBruta', (e.target.value))}
                            startAdornment={<InputAdornment position="start">R$</InputAdornment>}
                        />
                    </FormControl>
                </fieldset>

                <fieldset>
                    <legend>Educação</legend>
                    <FormControl className='item-form' style={{ minWidth: "250px" }} >
                        <InputLabel htmlFor="solAnoConcl2g">Ano de conclusão do ensino médio</InputLabel>
                        <Input
                            error={this.props.campoErros.solAnoConcl2g}
                            style={{ minWidth: "100px" }}
                            type="number"
                            fullWidth
                            id="solAnoConcl2g"
                            value={(this.props.solAnoConcl2g)}
                            onChange={(e) => this.props.changeCampoGenericoInteressado('solAnoConcl2g', (e.target.value))}
                            margin="none"
                        />
                    </FormControl>

                    <FormControl className='item-form' style={{ minWidth: "250px" }} >
                        <InputLabel htmlFor="solRede2g">Concluiu ensino médio em rede</InputLabel>
                        <Select
                            error={this.props.campoErros.solRede2g}
                            fullWidth
                            value={this.props.solRede2g}
                            onChange={(e) => this.props.changeCampoGenericoInteressado('solRede2g', e.target.value)}
                        >
                            <MenuItem value={""}>--Selecione--</MenuItem>
                            <MenuItem value={1}>Pública</MenuItem>
                            <MenuItem value={2}>Privada</MenuItem>
                        </Select>
                    </FormControl>

                    <div>
                        <FormControl className='item-form' style={{ minWidth: "300px" }} >
                            <InputLabel htmlFor="solEnem"> Participou do ENEM 2010 ou superior?        </InputLabel>
                            <Select
                                error={this.props.campoErros.solEnem}
                                fullWidth
                                value={this.props.solEnem}
                                onChange={(e) => this.props.changeCampoGenericoInteressado('solEnem', e.target.value)}
                            >
                                <MenuItem value={""}>--Selecione--</MenuItem>
                                <MenuItem value={"S"}>SIM</MenuItem>
                                <MenuItem value={"N"}>NÃO</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl className='item-form' style={{ minWidth: "250px" }} >
                            <InputLabel htmlFor="solAnoEnem">Ano do Último ENEM realizado</InputLabel>
                            <Input
                                disabled={this.props.solEnem !== "S"}
                                error={this.props.campoErros.solEnem}
                                style={{ minWidth: "100px" }}
                                type="number"
                                fullWidth
                                id="solAnoEnem"
                                value={(this.props.solAnoEnem)}
                                onChange={(e) => this.props.changeCampoGenericoInteressado('solAnoEnem', (e.target.value))}
                                margin="none"
                            />
                        </FormControl>
                        <FormControl className='item-form' style={{ minWidth: "200px" }} >
                            <InputLabel htmlFor="solPontEnem">Pontuação do ENEM</InputLabel>
                            <Input
                                disabled={this.props.solEnem !== "S"}
                                error={this.props.campoErros.solEnem}
                                style={{ minWidth: "100px" }}
                                type="text"
                                fullWidth
                                id="solPontEnem"
                                inputProps={{
                                    maxLength: 4
                                }}
                             
                                value={(this.props.solPontEnem)}
                                onChange={(e) => this.props.changeCampoGenericoInteressado('solPontEnem', (e.target.value))}
                                margin="none"
                            />
                        </FormControl>
                    </div>

                    <div>
                        <FormControl className='item-form' style={{ minWidth: "300px" }} >
                            <InputLabel htmlFor="solCursoSup"> Possui Curso superior?        </InputLabel>
                            <Select

                                error={this.props.campoErros.solCursoSup}
                                fullWidth
                                value={this.props.solCursoSup}
                                onChange={(e) => this.props.changeCampoGenericoInteressado('solCursoSup', e.target.value)}
                            >
                                <MenuItem value={""}>--Selecione--</MenuItem>
                                <MenuItem value={"S"}>SIM</MenuItem>
                                <MenuItem value={"N"}>NÃO</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl className='item-form' style={{ width: "40%", minWidth: "320px" }} >
                            <InputLabel htmlFor="solNomeCursoSup">Nome Curso Superior</InputLabel>
                            <Input
                                disabled={this.props.solCursoSup !== "S"}
                                error={this.props.campoErros.solNomeCursoSup}
                                style={{ minWidth: "100px" }}
                                type="text"
                                fullWidth
                                id="solNomeCursoSup"
                                value={(this.props.solNomeCursoSup)}
                                onChange={(e) => this.props.changeCampoGenericoInteressado('solNomeCursoSup', (e.target.value))}
                                margin="none"
                            />
                        </FormControl>

                    </div>
                </fieldset>
                <fieldset>
                    <legend>Estado Civil</legend>
                    <FormControl className='item-form' style={{ minWidth: "300px" }} >
                        <InputLabel htmlFor="pesEstCiv"> Estado civil    </InputLabel>
                        <Select
                            fullWidth
                            error={this.props.campoErros.pesEstCiv}
                            disabled={this.props.permissaoAlterar !== CONSTANTS._PERMISSAO.tudo}
                            value={this.props.pesEstCiv}
                            onChange={(e) => this.props.changeCampoGenericoInteressado('pesEstCiv', e.target.value)}
                        >
                            {/*                            
                            {"" , ""} ,
                            {"1" , "Solteiro"} ,
                            {"2" , "Casado"} ,
                            {"3" , "Viúvo"} ,
                            {"4" , "Divorciado" },
                            {"5" , "Desquitado"} ,
                            {"6" , "Outros"}                            
                            */}
                            <MenuItem value={0}>--Selecione--</MenuItem>
                            <MenuItem value={1}>  Solteiro</MenuItem>
                            <MenuItem value={2}>  Casado</MenuItem>
                            <MenuItem value={3}>  Viúvo</MenuItem>
                            <MenuItem value={4}>  Divorciado</MenuItem>
                            <MenuItem value={5}>  Desquitado</MenuItem>
                            <MenuItem value={6}>  Outro</MenuItem>
                        </Select>
                    </FormControl>
                    <fieldset style={{
                        display: this.props.pesEstCiv == 2 ? "block" : "none"
                    }}>

                        <legend> Dados do Cônjuge</legend>


                        <FormControl className='item-form' style={{}} >
                            <InputLabel htmlFor="conjugePesCPF">CPF</InputLabel>
                            <Input
                                error={this.props.campoErros.conjugePesCPF}
                                endAdornment={this.props.conjuge_cpfOK ?
                                    (<InputAdornment position="end"> <IconButton onClick={this.props.onEditarConjugeCPF} variant="fab" size="small" title="Editar"><EditIcon /></IconButton ></InputAdornment>) : null
                                }
                                disabled={this.props.conjuge_cpfOK}
                                style={{ minWidth: "150px" }}
                                type="number"
                                fullWidth
                                id="conjugePesCPF"
                                value={(this.props.conjugePesCPF)}
                                onChange={(e) => this.props.changeCampoGenericoInteressado('conjugePesCPF', (e.target.value))}
                                margin="none"
                            />
                        </FormControl>

                        <Button
                            style={{ display: !this.props.conjuge_cpfOK ? "inline-block" : "none" }}
                            disabled={this.props.carregandoPessoaCPF_conjuge}
                            onClick={this.props.onContinuarCPF_conjuge} variant="raised" color="primary" >
                            Continuar
                        </Button>

                        <div style={{ display: this.props.conjuge_cpfOK ? "block" : "none" }}>


                            {this.props.conjugePermissaoAlterar === CONSTANTS._PERMISSAO.naoPermitido ? divMsgCadastroExiste : null}


                            <FormControl className='item-form' style={{ width: "10%", minWidth: "150px" }}  >
                                <InputLabel htmlFor='nacCodigo'>Nacionalidade</InputLabel>
                                <Select
                                    id='conjugeNacCodigo'
                                    error={this.props.campoErros.conjugeNacCodigo}

                                    disabled={this.props.conjugePermissaoAlterar === CONSTANTS._PERMISSAO.naoPermitido}
                                    value={this.props.conjugeNacCodigo}
                                    onChange={(e) => this.props.changeCampoGenericoInteressado('conjugeNacCodigo', e.target.value)}
                                >
                                    {this.props.listNacionalidade.map((item) => {
                                        return (
                                            <MenuItem key={item.nac_codigo} value={item.nac_codigo}>{item.nac_descricao}</MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>


                            <FormControl className='item-form' style={{ width: "40%", minWidth: "320px" }} >
                                <TextField
                                    error={this.props.campoErros.conjugePesCPF}
                                    disabled={this.props.conjugePermissaoAlterar === CONSTANTS._PERMISSAO.naoPermitido}
                                    type="text"
                                    fullWidth
                                    id="conjugePesNome"
                                    label="Nome"
                                    value={this.props.conjugePesNome}
                                    onChange={(e) => this.props.changeCampoGenericoInteressado('conjugePesNome', e.target.value)}
                                    margin="normal"
                                />
                            </FormControl>
                            <FormControl className='item-form' style={{ width: "10%", minWidth: "120px" }}  >
                                <TextField
                                    error={this.props.campoErros.conjugePesCPF}
                                    disabled={this.props.conjugePermissaoAlterar === CONSTANTS._PERMISSAO.naoPermitido}
                                    type="text"
                                    fullWidth
                                    id="conjugePesRG"
                                    label="RG"
                                    value={this.props.conjugePesRG}
                                    onChange={(e) => this.props.changeCampoGenericoInteressado('conjugePesRG', e.target.value)}
                                    margin="normal"
                                />
                            </FormControl>
                            <FormControl className='item-form' style={{ width: "10%", minWidth: "120px" }}  >
                                <TextField
                                    InputProps={{ maxLength: 10 }}
                                    error={this.props.campoErros.conjugePesOrgExp}                                 
                                    type="text"
                                    fullWidth
                                    placeholder="SSP"
                                    label="Orgão Expedidor  "
                                    value={this.props.conjugePesOrgExp}
                                    onChange={(e) => this.props.changeCampoGenericoInteressado('conjugePesOrgExp', e.target.value)}
                                    margin="normal"
                                />
                            </FormControl>

                            <FormControl className='item-form' style={{ width: "10%", minWidth: "150px" }}  >
                                <InputLabel htmlFor='conjugePesEstExp'>Estado Expedidor</InputLabel>
                                <Select
                                    id='conjugePesEstExp'
                                    error={this.props.campoErros.conjugePesEstExp}
                                    disabled={this.props.conjugePermissaoAlterar === CONSTANTS._PERMISSAO.naoPermitido}
                                    value={this.props.conjugePesEstExp}
                                    onChange={(e) => this.props.changeCampoGenericoInteressado('conjugePesEstExp', e.target.value)}
                                >
                                    {this.props.listEstados.map((item) => {
                                        return (
                                            <MenuItem key={item} value={item}>{item}</MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>


                            <div>
                                <FormControl className='item-form' style={{ width: "15%", minWidth: '150px' }}  >
                                    <TextField
                                        error={this.props.campoErros.conjugePesCPF}
                                        disabled={this.props.conjugePermissaoAlterar === CONSTANTS._PERMISSAO.naoPermitido}
                                        type="date"
                                        fullWidth
                                        id="conjugePesDtNasc"
                                        label="Data de Nascimento"
                                        value={formataDataDDMMYYYYParaHTML5(this.props.conjugePesDtNasc) || '0000-00-00'}
                                        onChange={(e) => { this.props.changeCampoGenericoInteressado('conjugePesDtNasc', formataDataHTML5ParaDDMMYYYY(e.target.value)); }}
                                        margin="normal"
                                    />
                                </FormControl>





                                <FormControl className='item-form' style={{ width: "12%", minWidth: "120px" }}  >
                                    <TextField
                                        error={this.props.campoErros.conjugePesCPF}
                                      
                                        type="text"
                                        fullWidth
                                        placeholder="(00)0000-0000"
                                        id="pes-telefone"
                                        label="Telefone Fixo"
                                        value={mascaraCelular9Digito(this.props.conjugePesTelefone)}
                                        onChange={(e) => this.props.changeCampoGenericoInteressado('conjugePesTelefone', mascaraCelular9Digito(e.target.value))}
                                        margin="normal"
                                    />
                                </FormControl>
                                <FormControl className='item-form' style={{ width: "12%", minWidth: "120px" }}  >
                                    <TextField
                                        error={this.props.campoErros.conjugePesCPF}
                                   
                                        type="text"
                                        fullWidth
                                        placeholder="(00)00000-0000"
                                        id="pes-celular"
                                        label="Celular"
                                        value={mascaraCelular9Digito(this.props.conjugePesCelular)}
                                        onChange={(e) => this.props.changeCampoGenericoInteressado('conjugePesCelular', mascaraCelular9Digito(e.target.value))}
                                        margin="normal"
                                    />
                                </FormControl>
                                <FormControl className='item-form' >
                                    <InputLabel >Sexo</InputLabel>
                                    <Select
                                        disabled={this.props.conjugePermissaoAlterar === CONSTANTS._PERMISSAO.naoPermitido}
                                        error={this.props.campoErros.conjugePesSexo}
                                        style={{ width: "200px" }}
                                        value={(this.props.conjugePesSexo || 0).toString()}
                                        onChange={(e) => this.props.changeCampoGenericoInteressado('conjugePesSexo', e.target.value)}
                                    >
                                        <MenuItem value={'0'}>--Selecione--</MenuItem>
                                        <MenuItem value={'1'}>Masculino</MenuItem>
                                        <MenuItem value={'2'}>Feminino</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                            <fieldset>
                                <legend>Empresa/Conjugê</legend>


                                <FormControl className='item-form' style={{ width: "40%", minWidth: "220px" }}  >
                                    <TextField
                                        error={this.props.campoErros.conjugePesEmpresa}
                                        type="text"
                                        fullWidth
                                        id="conjugePesEmpresa"
                                        label="Empresa onde trabalha"
                                        value={(this.props.conjugePesEmpresa)}
                                        onChange={(e) => this.props.changeCampoGenericoInteressado('conjugePesEmpresa', (e.target.value))}
                                        margin="normal"
                                    />
                                </FormControl>

                                <FormControl className='item-form' style={{ width: "15%", minWidth: '150px' }}  >
                                    <TextField
                                        error={this.props.campoErros.conjugePesDtAdmissao}
                                        type="date"
                                        fullWidth
                                        id="conjugePesDtAdmissao"
                                        label="Data de Admissão"
                                        value={formataDataDDMMYYYYParaHTML5(this.props.conjugePesDtAdmissao) || '0000-00-00'}
                                        onChange={(e) => this.props.changeCampoGenericoInteressado('conjugePesDtAdmissao', formataDataHTML5ParaDDMMYYYY(e.target.value))}
                                        margin="normal"
                                    />
                                </FormControl>

                                <FormControl className='item-form' style={{ width: "40%", minWidth: "220px" }}  >
                                    <TextField
                                        error={this.props.campoErros.conjugePesCargo}
                                        type="text"
                                        fullWidth
                                        id="conjugePesCargo"
                                        label="Cargo/Profissão"
                                        value={(this.props.conjugePesCargo)}
                                        onChange={(e) => this.props.changeCampoGenericoInteressado('conjugePesCargo', (e.target.value))}
                                        margin="normal"
                                    />
                                </FormControl>

                                <FormControl className='item-form' style={{ width: "40%", minWidth: "220px" }}  >
                                    <InputLabel htmlFor="conjugePesRendaBruta">Renda pessoal bruta mensal</InputLabel>
                                    <Input
                                        error={this.props.campoErros.conjugePesRendaBruta}
                                        type="text"
                                        fullWidth
                                        id="conjugePesRendaBruta"
                                        placeholder="00,00"
                                        value={(this.props.conjugePesRendaBruta && this.props.conjugePesRendaBruta.toString().replace(/\./gim, ","))}
                                        onChange={(e) => this.props.changeCampoGenericoInteressado('conjugePesRendaBruta', (e.target.value))}
                                        startAdornment={<InputAdornment position="start">R$</InputAdornment>}
                                    />
                                </FormControl>
                            </fieldset>



                        </div>
                    </fieldset>

                </fieldset>
            </div>
        );


        if (this.props.cpfOK) {
            cpf = null;
        } else {
            outrosDados = null;
        }

        console.warn(this.props);
        return (
            <div >
                {this.props.carregando ? <LinearProgress color="primary" /> : null}
                {cpf}
                {outrosDados}
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/dados-interessado.js